import React, { useEffect, useState, useContext } from "react";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { AuthContext } from "../../context/Auth/AuthContext";
import baseUrl from "../../config/baseUrl";
import Loading from "../material-ui/Loading";
import getClientName from "../../api/getClientName";

function BusinessCardInfo({ clientID }) {
  const [hovered, setHovered] = useState(false);
  const [clientData, setClientData] = useState(null); // <-- for storing fetched data
  const { token } = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  // DMS-local client details - sourced from getCaseStatus (reference number, phone,
  // email) and getClientName (name), no SugarCRM dependency.
  const fetchCurrentClientData = async (clientId) => {
    try {
      setLoading(true);

      const [caseStatusResponse, clientNameResponse] = await Promise.all([
        fetch(`${baseUrl}/api/getCaseStatus?caseId=${clientId}`, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }),
        getClientName({ contact_id: clientId, token }),
      ]);

      const data = await caseStatusResponse.json();
      const caseDetail = data?.caseDetails?.[0];

      setClientData({
        name: clientNameResponse?.data?.name || "",
        caseid_c: caseDetail?.caseid_c || "",
        phone_mobile: caseDetail?.phone_mobile || "",
        email: caseDetail?.email_id || "",
      });
    } catch (error) {
      console.error("Error fetching client data:", error);
      setClientData(null);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (clientID && clientID !== "null") {
      fetchCurrentClientData(clientID);
    }
  }, [clientID]);

  useEffect(() => {
    if (!clientID) {
      setClientData(null);
    }
  }, [clientID]);

  return (
    <div
      style={{
        position: "relative",
        display: `${!clientID ? "none" : "inline-block"} `,
      }}
      onMouseEnter={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
    >
      {/* Same tile style as the other document-viewer action icons; the
          hover card below remains the details popover for this icon. */}
      <span
        role="img"
        aria-label="Client details"
        className="flex h-9 w-9 cursor-pointer items-center justify-center rounded-lg border border-sky-200 bg-sky-100 text-sky-600 shadow-sm transition-colors hover:bg-sky-200"
      >
        <InfoOutlinedIcon sx={{ fontSize: 20 }} />
      </span>

      {hovered && (
        <div
          style={{
            position: "absolute",
            top: "50px",
            left: "50%",
            transform: "translateX(-50%)",
            backgroundColor: "#fff",
            padding: "15px 25px",
            borderRadius: "10px",
            boxShadow: "0 10px 20px rgba(0, 0, 0, 0.15)",
            border: "2px solid #1a6b7c",
            width: "400px",
            fontSize: "14px",
            color: "#333",
            textAlign: "left",
            zIndex: "999",
          }}
          className="w-[90%] md:w-[400px] text-sm shadow-lg transition-all duration-200 ease-in-out"
        >
          {loading ? (
            <div className="flex justify-center items-center h-[250px]">
              <Loading />
            </div>
          ) : (
            <div className="grid grid-cols-[auto,1fr] gap-y-2 gap-x-3">
              {/* SugarCRM-specific fields (Alien Number, Case Status, Lead Attorney,
                  Active Legal Assistant, Active Paralegal) removed - DMS standalone
                  now only shows local client fields below.
              <span className="font-semibold text-gray-700">Alien Number</span>
              <span className="text-gray-900">
                : {clientData?.im_alien_number_c || ""}
              </span>

              <span className="font-semibold text-gray-700">Case Status</span>
              <span className="text-gray-900">
                : {clientData?.status || ""}
              </span>

              <span className="font-semibold text-gray-700">Lead Attorney</span>
              <span className="text-gray-900">
                : {clientData?.Lead_Attorney || ""}
              </span>

              <span className="font-semibold text-gray-700">
                Active Legal Assistant
              </span>
              <span className="text-gray-900">
                : {clientData?.Legal_Assistant || ""}
              </span>

              <span className="font-semibold text-gray-700">
                Active Paralegal
              </span>
              <span className="text-gray-900">
                : {clientData?.Paralegal || ""}
              </span>
              */}
              <span className="font-semibold text-gray-700 whitespace-nowrap">
                Client Ref. No.
              </span>
              <span className="text-gray-900">
                : {clientData?.caseid_c || ""}
              </span>

              <span className="font-semibold text-gray-700">Name</span>
              <span className="text-gray-900">: {clientData?.name || ""}</span>

              <span className="font-semibold text-gray-700">Phone</span>
              <span className="text-gray-900">
                : {clientData?.phone_mobile || ""}
              </span>

              <span className="font-semibold text-gray-700">Email</span>
              <span className="text-gray-900">: {clientData?.email || ""}</span>
            </div>
          )}
        </div>
      )}
    </div>
  );
}

export default BusinessCardInfo;
